
import Routes from '@/Routes';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AppEvents from '@/AppEvents';
import { RouteConfig } from 'vue-router';
import User from '@/models/User';
import { ModelStateError } from '@/services/BaseService';
import IApiError from '@/models/IApiError';

@Component({
  components: {
  },
})
export default class SignInAzureAdPage extends Vue {
  signingInWithAzureAd: boolean = false;
  apiErrors: IApiError[] = [];

  setLocale(locale){
    this.$store.dispatch("app/setLocale", locale);
  }

  get signInRoute(): RouteConfig {
    return Routes.signInRoute;
  }

  get isAuthenticated() {
    return this.$store.getters["auth/isAuthenticated"];
  }
 
  async onLoginSuccess(){
    await this.$store.dispatch('user/getMe');
    const me: User = (this.$store.state as any).user.me as User;
    this.$root.$emit(AppEvents.APP_LOGIN_SUCCESS);
    
    // check if user has organization access
    if (me.organizationIds && me.organizationIds.length > 0) {
      this.$router.push({
        name: Routes.organizationRoute.name,
        params: {
          organizationId: me.organizationIds[0],
        },
      });
    } else {
      if (this.$route.query && this.$route.query.redirect){
        this.$router.push(this.$route.query.redirect.toString());
      } else {
        this.$router.push(Routes.rootRoute);
      }
    }
  }

  async created(){
    if (this.isAuthenticated) {
      this.$router.push(Routes.rootRoute);
    }

    if (!this.isAuthenticated) {
      this.signingInWithAzureAd = true;
      try {
        const loginResult = await this.$store.dispatch(
          'auth/azureAdSignInOrSignUp'
        );
      } catch (e) {
        this.apiErrors = AppEvents.getApiErrorsFromError(e);
        console.error("loginError", e);
      }
      if (this.isAuthenticated) {
        await this.onLoginSuccess();
        this.signingInWithAzureAd = false;
      } else {
        console.error("Something went wrong with the Microsoft 365 login");
      }
    }
  }
};
